"use strict";

exports.__esModule = true;
exports.getUserFormData = getUserFormData;
function getUserFormData(user) {
  if (user) {
    return {
      isEnabled: user.isEnabled,
      username: user.username,
      password: "",
      rePassword: "",
      email: user.profile && user.profile.email ? user.profile.email : "",
      firstName: user.profile && user.profile.name && user.profile.name.first ? user.profile.name.first : "",
      lastName: user.profile && user.profile.name && user.profile.name.last ? user.profile.name.last : "",
      plants: user.plants,
      roles: user.roles,
      isEditable: user.isEditable
    };
  }
  return {
    isEnabled: true,
    username: "",
    password: "",
    rePassword: "",
    email: "",
    firstName: "",
    lastName: "",
    plants: [],
    roles: [],
    isEditable: true
  };
}